import permissions from './permissions.json';

export const isEmailBlocked = (email: string) => {
  const domain = email.split('@')[1];
  return permissions.blocklist.domains.includes(domain);
};
